// extracted by mini-css-extract-plugin
module.exports = {"returnLink":"headline-comments_returnLink__92ECj","returnIcon":"headline-comments_returnIcon__IgKoW","commentOn":"headline-comments_commentOn__KXWHo"};